export default "__VITE_ASSET__16fbab1d__"